import CheckPasswordModal from 'components/GlobalModals/CheckPasswordModal/CheckPasswordModal';
import { withCheckPasswordModalProps } from 'viewModel/globalModals/checkPasswordModal/withCheckPasswordModal';

export default withCheckPasswordModalProps(CheckPasswordModal);
